// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2c1Xl","rootNoMargin":"styles_rootNoMargin__3JPKo"};